import { useState } from 'react';
import styled from 'styled-components';
import ReactSelect from 'react-select';
import {
  generateOption,
  generateOptsArray,
  NONE_VALUE,
  PLACEHOLDER_VALUE,
} from './helpers/generateOptions';

const StyledSelect = styled(ReactSelect)`
  .select__control {
    border: none;
    border-radius: 0;
    box-shadow: none;
    background-color: ${(props) => props.theme.color.gray50};

    &:hover {
      border-color: transparent;
    }

    .select__value-container {
      height: 50px;
      padding: 13px 16px;
    }
    .select__indicator-separator {
      display: none;
    }
    .select__indicators {
      cursor: pointer;
      height: 50px;
      background-color: ${(props) => props.theme.color.primary800};
      .select__indicator {
        padding: 16px;
        color: ${(props) => props.theme.color.white500};
        > svg {
          width: 30px;
          height: 30px;
        }
      }
    }

    &.select__control--menu-is-open {
      box-shadow: none;
      .select__indicator > svg {
        transform: rotate(180deg);
      }
    }
  }
  .select__menu {
    margin: 0;
    border-radius: 0;
    box-shadow: none;
    z-index: 10;
    border: 1px solid ${(props) => props.theme.color.gray500};
    .select__menu-list {
      padding: 0;
    }
    .select__option {
      cursor: pointer;
      border-top: 1px solid ${(props) => props.theme.color.gray500};
      padding: 13px 16px;
      color: ${(props) => props.theme.color.primary800};
      background-color: ${(props) => props.theme.color.gray50};

      &.select__option--is-disabled {
        color: ${(props) => props.theme.color.gray500};
      }
      &.select__option--is-focused {
        background-color: ${(props) => props.theme.color.gray300};
      }
    }
    .select__placeholder {
      color: ${(props) => props.theme.color.gray500};
    }
  }
`;

/**
 * @param {SelectBoxProps} props
 * @returns {React.ReactElement}
 */
const SelectBox = ({
  options,
  placeholder = '...',
  handleSelect,
  deselectOption,
  activeValue = PLACEHOLDER_VALUE,
  activeIds,
  className,
  activeValueSetFromOutside,
}) => {
  const selectOptions = generateOptsArray(
    options,
    deselectOption?.description ?? undefined,
    deselectOption?.disabled ?? false,
  );

  const handleActiveValue = () => {
    let activeOption = generateOption(placeholder, PLACEHOLDER_VALUE);
    if (activeIds) {
      activeOption =
        selectOptions.find(
          (option) => activeIds.indexOf(option.value) !== -1,
        ) || generateOption(placeholder, PLACEHOLDER_VALUE);
    }
    return activeOption;
  };

  const [value, setActiveValue] = useState(
    selectOptions.find((option) => option.value === activeValue),
  );

  /**
   * @param option
   * @returns {void}
   */
  const handleOnChange = (option) => {
    setActiveValue(option);

    if (deselectOption && option.value === NONE_VALUE) {
      deselectOption.handleSelect(option);
    } else if (handleSelect) {
      handleSelect(option);
    }
  };

  return (
    <StyledSelect
      instanceId="react-select"
      inputId="react-select"
      classNamePrefix="select"
      value={activeValueSetFromOutside ? handleActiveValue() : value}
      placeholder={placeholder}
      isMulti={false}
      onChange={(option) => handleOnChange(option)}
      className={className}
      options={selectOptions}
      isSearchable={false}
      blurInputOnSelect={true}
    />
  );
};

export default SelectBox;
